<!-- Global notifications in bottom-right corner -->
<div class="notification-container">
    @for (notification of visibleNotifications; track notification) {
        <div class="notification-item notification-visible notification-success">
            <!-- Title -->
            <div class="notification-header">
                <span class="notification-title">{{ notification.title }}</span>
                <button class="notification-close" (click)="closeNotification(notification.id)" title="Close">✕</button>
            </div>
            <!-- JSON Data only -->
            <div class="notification-body">
                <div class="notification-data">{{ getNotificationData(notification) }}</div>
            </div>
            <!-- Time -->
            <div class="notification-time">
                {{ notification.timestamp | date: 'HH:mm:ss' }}
            </div>
        </div>
    }
</div>
